import UpdateRetailer from "../../../components/@users/retailers/UpdateRetailer";
import UpdateOutletUser from "../../../components/@branch_users/retailers/UpdateOutletUser"

import { routeTypes } from "../../../hooks/useSystemRoutes";

import { useAuthAccess } from "../../../hooks/useAuthAccess";

export default function ProfilePage() {

    const { authData } = useAuthAccess()

    let id = authData?.profile?.parentUserId

    if(authData?.profile?.parentUserId === 0){ // is retailer
        // return UpdateRetailer({
        //     routeType: routeTypes.retail,
        //     isOwnProfile: true
        // })

        return (
            <UpdateRetailer 
                routeType={routeTypes.retail}
                isOwnProfile={Boolean(true)}
            />
        )
    }

     // if outlet user
    // return UpdateOutletUser({
    //     routeType: routeTypes.retail,
    //     isOwnProfile: true,
    //     parentId: authData?.profile?.parentUserId
    // })
    
    return (
        <UpdateOutletUser 
            routeType={routeTypes.retail}
            isOwnProfile={Boolean(true)}
            parentId={id}
        />
    )
   
}       